import React from "react";
import PropTypes from "prop-types";
import styles from "./EagleHeader.module.css";
import IconSetting from "./Images/icon-settings.svg";
import { useTranslation } from "react-i18next";

export function EagleHeader({
  header = "",
  color = "#000000",
  onClick = null,
  count = null,
  rightLabel = null,
  chip = null,
}) {
  const { t } = useTranslation();

  return (
    <div className={styles.headerWrapper}>
      <div className={styles.headerContainer}>
        <div className={styles.titleContainer}>
          <span style={{ color: color }}>{t(header)}</span>
        </div>
        {count !== null && (
          <div className={styles.countContainer}>
            <span className={styles.count}>{count}</span>
          </div>
        )}
        {rightLabel !== null && (
          <div className={styles.rightLabelContainer}>
            <span className={styles.rightLabel}>{rightLabel}</span>
          </div>
        )}
        {onClick && (
          <div className={styles.iconContainer}>
            <img src={IconSetting} className={styles.icon} onClick={onClick} />
          </div>
        )}
      </div>
      {chip && (
        <div className={styles.chipRow}>
          <span className={styles.chip}>{chip}</span>
        </div>
      )}
    </div>
  );
}

EagleHeader.propTypes = {
  header: PropTypes.string.isRequired,
  color: PropTypes.string,
  onClick: PropTypes.func,
  count: PropTypes.number,
  rightLabel: PropTypes.string,
  chip: PropTypes.string,
};
